import axios from "axios";
import Route from '../route';

$(function () {
    if (Route === "account-preferences" || Route === "my-lt-preferences") {

        $(".chkPreferences").on("change", function () {
            const preferenceId = $(this).attr('data-preferenceId');
            const value = $(this).val();
            if (!$(this).is(':checked')) {
                removePreference(preferenceId, value);
            } else {
                addPreference(preferenceId, value);
            }
        });

        $(".sel-subscription-preference").on("change", function () {
            const preferenceId = $(this).attr('data-preferenceId');
            const value = $(this).val();
            // upsert (single value preference)
            addPreference(preferenceId, value);
        });

        function addPreference(preferenceId, value) {
            axios
                .post('/account/add-preference', {"preferenceId": preferenceId, "value": value});
        }

        function removePreference(preferenceId, value) {
            axios
                .post('/account/remove-preference', {"preferenceId": preferenceId, "value": value});
        }
    }
});
